// import { login, logout, getUserInfo } from '@/api/login'
import { getToken, removeToken } from '@/utils/auth';
import { getUserInfo } from '@/backend/services/sso/sso';
import watermark from '@/utils/watermark';

const user = {
	state: {
		token: getToken(),
		name: '',
		avatar: '',
		roles: [],
		userInfo: {},
	},

	mutations: {
		SET_TOKEN: (state, token) => {
			state.token = token;
		},
		SET_NAME: (state, name) => {
			state.name = name;
		},
		SET_USER: (state, user) => {
			state.userInfo = user;
		},
		SET_AVATAR: (state, avatar) => {
			state.avatar = avatar;
		},
		SET_ROLES: (state, roles) => {
			state.roles = roles;
		},
	},

	actions: {
		// 获取用户信息
		GetUserInfo({ commit }) {
			return new Promise(reject => {
				getUserInfo()
					.then(response => {
						const data = response.data;
						if (data !== 'notoken') {
							commit('SET_NAME', data.username);
							commit('SET_USER', data);
							let { username, number, deptName } = data;
							let watermarkText = `${username}(${number})${deptName}`;
							watermark.set(watermarkText);
						} else {
							reject('notoken');
						}
					})
					.catch(error => {
						reject(error);
					});
			});
		},

		// 登出
		LogOut({ commit }) {
			return new Promise(resolve => {
				commit('SET_TOKEN', '');
				commit('SET_ROLES', []);
				removeToken();
				resolve();
			});
		},

		// 前端 登出
		FedLogOut({ commit }) {
			return new Promise(resolve => {
				commit('SET_TOKEN', '');
				removeToken();
				localStorage.clear();
				location.href = process.env.VUE_APP_LOGOUT + 1;
				resolve();
			});
		},
	},
};

export default user;
